import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, Card, CardContent, Typography, Alert } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';

const ProtectedRoute = ({ children, requireApproval = true }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  // Wenn nicht authentifiziert, zur Login-Seite weiterleiten
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Wenn Freischaltung erforderlich ist, aber Benutzer nicht freigeschaltet
  if (requireApproval && user && !user.is_approved) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 3,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}
      >
        <Card
          sx={{
            maxWidth: 500,
            borderRadius: 3,
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            <LockIcon
              sx={{
                fontSize: 64,
                color: '#FFD700',
                mb: 2,
              }}
            />
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 2, color: '#333' }}>
              Zugriff eingeschränkt
            </Typography>
            <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
              <Typography variant="body1">
                <strong>Hallo {user.username}!</strong>
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Ihr Account wurde erfolgreich erstellt, muss aber noch von einem Administrator 
                freigeschaltet werden, bevor Sie alle Funktionen nutzen können.
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Sie können derzeit nur das Dashboard einsehen. Sobald Ihr Account freigeschaltet 
                wurde, haben Sie Zugriff auf alle Bereiche des Admin-Panels.
              </Typography>
            </Alert>
            <Typography variant="body2" color="text.secondary">
              Bitte wenden Sie sich an den Administrator oder warten Sie auf die Freischaltung.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;
